/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import store from '@/store';
import OrderPrdItem from './components/OrderPrdItem';
import AddressDesc from './components/AddressDesc';
import FixBottomBtn from './components/FixBottomBtn';
import AddressPopup from './components/AddressPopup';
import FlexCell from '@/components/FlexCell';
import TransferDom from "vux/src/directives/transfer-dom/index.js";
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { GETTER_CLINICOBJ, ACTION_MALL_ADDRESSLIST, GETTER_MALL_ADDRESSLIST, MUTATION_MALL_NOWADDRESS, GETTER_MALL_NOWADDRESS, MUTATION_MALL_ORDERINFOSURE } from '@/store/mutation_types';
import { OrderPlace, AddressSelect } from '@/api/mall';
import Cons from "Constant";
export default {
  data: function data() {
    return {
      showAddress: false,
      // nowAddress:{},
      leave: false,
      hasAddressGet: false
    };
  },
  created: function created() {
    console.log('create:  ');
    this.getAddressList();
  },
  // beforeRouteEnter (to, from, next) {
  //   next(vm=>{
  //     vm.leave = false;
  //     vm.getAddressList();
  //   })
  // },
  // beforeRouteLeave(to, from, next){
  //   console.log(to.name);
  //   this.leave = true;
  //   console.log('leave:    '+this.leave);
  //   next();
  // },
  components: {
    OrderPrdItem: OrderPrdItem,
    FlexCell: FlexCell,
    AddressDesc: AddressDesc,
    FixBottomBtn: FixBottomBtn,
    AddressPopup: AddressPopup
  },
  directives: {
    TransferDom: TransferDom
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState({
    orderInfoList: function orderInfoList(state) {
      return state.mall.orderInfo.orderList;
    },
    isSubmit: function isSubmit(state) {
      return state.mall.orderInfo.isSubmit;
    }
  })), mapGetters({
    clinicObj: GETTER_CLINICOBJ,
    addressListGet: GETTER_MALL_ADDRESSLIST,
    nowAddressId: GETTER_MALL_NOWADDRESS
  })), {}, {
    // 运费
    freight: function freight() {
      var freight = 0;
      var orderInfoList = this.orderInfoList;

      if (this.isReal == 0) {
        return 0;
      }

      if (orderInfoList && orderInfoList.length > 0) {
        var orderTmp = {}; //商品id分块

        for (var i = 0; i < orderInfoList.length; i++) {
          if (!orderTmp[orderInfoList[i].goodsId]) {
            var arr = [];
            arr.push(orderInfoList[i]);
            orderTmp[orderInfoList[i].goodsId] = arr;
          } else {
            orderTmp[orderInfoList[i].goodsId].push(orderInfoList[i]);
          }
        }

        for (var _i in orderTmp) {
          var num = 0;

          var _iterator = _createForOfIteratorHelper(orderTmp[_i]),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              num += item.goodsQty;
              orderTmp[_i].num = num;
              orderTmp[_i].freight = item.freight;
              orderTmp[_i].subFreight = item.subFreight;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          freight += orderTmp[_i].freight + (orderTmp[_i].num - 1) * orderTmp[_i].subFreight;
        }

        console.log("orderTmp");
        console.log(orderTmp);
      }

      return freight;
    },
    // 商品价格
    price: function price() {
      var orderInfoList = this.orderInfoList,
          price = 0;

      if (orderInfoList && orderInfoList.length > 0) {
        var _iterator2 = _createForOfIteratorHelper(orderInfoList),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            price += item.goodsQty * item.price;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      price = price.toFixed(2);
      return price;
    },
    //总价：运费+商品总价
    priceTotal: function priceTotal() {
      var p = parseFloat(this.price) + parseFloat(this.freight);
      p = p.toFixed(2);
      return p;
    },
    //是否是虚拟商品下单
    isReal: function isReal() {
      var prdList = this.orderInfoList;

      if (prdList.some(function (x) {
        return x.isReal == 0;
      })) {
        return 0;
      } else {
        return 1;
      }
    },
    //地址列表
    addressList: function addressList() {
      return this.addressListGet;
    },
    //默认地址
    defaultAddress: function defaultAddress() {
      var defaultAddress = {};

      if (this.addressList.length > 0) {
        defaultAddress = this.addressList.find(function (x) {
          return x.isDefaultAddr == 1;
        });

        if (defaultAddress) {
          defaultAddress.fullAddress = this.getFullAddress(defaultAddress);
        }
      }

      return defaultAddress;
    },
    nowAddress: function nowAddress() {
      var _this = this;

      var address = {};

      if (this.addressList.length > 0 && this.nowAddressId) {
        address = this.addressList.find(function (x) {
          return x.userAddressId == _this.nowAddressId;
        });

        if (address) {
          address.fullAddress = this.getFullAddress(address);
        }
      }

      return address;
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions({
    actionAddressList: ACTION_MALL_ADDRESSLIST
  })), mapMutations({
    MUTATION_MALL_NOWADDRESS: MUTATION_MALL_NOWADDRESS,
    MUTATION_MALL_ORDERINFOSURE: MUTATION_MALL_ORDERINFOSURE
  })), {}, {
    //显示地址选择弹窗
    showAddressPopup: function showAddressPopup() {
      this.showAddress = true;
    },
    //设置地址选择弹窗效果
    setShow: function setShow(val) {
      this.showAddress = val;
    },
    //新建地址
    newAddress: function newAddress() {
      this.$router.push({
        name: 'MallAddress'
      });
    },
    //订单提交下单
    orderSumbit: function orderSumbit() {
      var _this2 = this;

      var param = {};
      var itemList = [],
          itemObj = {},
          cartIdList = [];
      var prdList = this.orderInfoList,
          nowAddress = {};

      if (!this.isSubmit) {
        return;
      }

      if (!this.nowAddressId && !this.defaultAddress.userAddressId) {
        Public.tips({
          text: '请新增收货人信息'
        });
        return;
      }

      if (!this.nowAddressId) {
        nowAddress = this.defaultAddress;
      } else {
        nowAddress = this.nowAddress;
      }

      param.consignee = nowAddress.userName;
      param.consigneeMobile = nowAddress.phoneNumber;
      param.consigneeAddress = nowAddress.fullAddress;
      param.realPrice = parseFloat(this.priceTotal);
      param.freight = parseFloat(this.freight);

      var _iterator3 = _createForOfIteratorHelper(prdList),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          itemObj = {};
          itemObj.goodsId = item.goodsId;
          itemObj.goodsName = item.goodsName;
          itemObj.goodsQty = item.goodsQty;
          itemObj.goodsPrice = item.price;
          itemObj.isReal = item.isReal;
          itemObj.goodsSpecifitionId = item.goodsSpecifitionId;
          itemObj.goodsSpecifition = item.goodsSpecifition;
          itemObj.picUrl = item.picUrl;
          itemList.push(itemObj);

          if (item.cartId) {
            cartIdList.push(item.cartId);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (this.isReal == 1 && cartIdList.length > 0) {
        cartIdList = JSON.stringify(cartIdList);
        param.cartIdList = cartIdList;
      }

      itemList = JSON.stringify(itemList);
      param.itemList = itemList;
      console.log(param);
      OrderPlace(param).then(function (data) {
        //下单成功
        if (data) {
          var orderInfo = {};
          orderInfo.orderList = prdList;
          orderInfo.isSubmit = false;

          _this2.MUTATION_MALL_ORDERINFOSURE(orderInfo);

          if (Cons.ENV_DEBUG) {
            _this2.$router.replace({
              name: 'PayMallPay',
              query: {
                orderNo: data,
                price: _this2.priceTotal
              }
            });
          } else {
            var appId = Utils.getSessionCache(Cons.APPID);
            var clinicId = Utils.getSessionCache(Cons.CLINIC_ID); // window.location.href = Cons.SCRM_PATH + `pay/mallPay?orderNo=${data}&price=${this.priceTotal}&appId=${appId}&clinicId=${clinicId}`

            window.location.replace("".concat(Cons.SCRM_PATH, "pay/mallPay?orderNo=").concat(data, "&price=").concat(_this2.priceTotal, "&appId=").concat(appId, "&clinicId=").concat(clinicId));
          }
        } else {
          Public.tips({
            text: '返回订单号为空'
          });
        }
      });
    },

    /**地址列表 */
    getAddressList: function getAddressList() {
      var _this3 = this;

      this.actionAddressList().then(function () {
        _this3.hasAddressGet = true;
      });
    },
    //得到完整地址信息
    getFullAddress: function getFullAddress(addressItem) {
      var f = '';

      if (addressItem.provinceName) {
        f += addressItem.provinceName;
      }

      if (addressItem.cityName) {
        f += addressItem.cityName;
      }

      if (addressItem.districtName) {
        f += addressItem.districtName;
      }

      if (addressItem.detailAddress) {
        f += addressItem.detailAddress;
      }

      return f;
    },
    //点击地址check
    addressItemCheck: function addressItemCheck(id) {
      // let nowAddress = this.addressList.find(x=>x.userAddressId==id);
      // nowAddress.fullAddress = this.getFullAddress(nowAddress);
      // this.nowAddress = nowAddress;
      this.MUTATION_MALL_NOWADDRESS(id);
    },
    editAddress: function editAddress(userAddressId) {
      var n = this.addressList.find(function (x) {
        return x.userAddressId == userAddressId;
      });
      this.$router.push({
        name: 'MallAddress',
        query: {
          userAddressId: userAddressId,
          isEdit: true
        }
      });
    }
  })
};